import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=0fbde54a&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=0fbde54a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbde54a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fbde54a')) {
      api.createRecord('0fbde54a', component.options)
    } else {
      api.reload('0fbde54a', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=0fbde54a&scoped=true&", function () {
      api.rerender('0fbde54a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2bz3z9Xm55MeJ/JS/comp/SearchFilterTokens.vue"
export default component.exports